import { ChatMessageRequest, ChatMessageResponse, Sender } from './messaging.model';
import { Message } from '@tribeauto/ngx-mobilite-material';

export const chatMessageRequestToMessage = (chatMessageRequest: ChatMessageRequest, id: number): Message => ({
  id: id,
  content: chatMessageRequest.content,
  date: new Date(),
  isMyMessage: true,
  isBeingSent: true
});

export const getMessageListFromChatMessageResponse = (chatMessageResponseList: ChatMessageResponse[]): Message[] =>
  chatMessageResponseList.map(chatMessageResponse => ({
    id: chatMessageResponse.id,
    content: chatMessageResponse.content,
    date: new Date(chatMessageResponse.creationDate),
    isMyMessage: chatMessageResponse.sender === Sender.FRONT,
    isBeingSent: false
  }));
